var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('textarea',{staticClass:"v-input v-textarea px-2",class:{'theme--dark': _vm.$vuetify.theme.dark},attrs:{"readonly":_vm.readonly,"spellcheck":false},domProps:{"value":_vm.value},on:{"change":function($event){return _vm.emitChange($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }